import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-estatistico`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMotoristas(queryParms = {}) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms = {}) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        getDestinos(queryParms = {}) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        },
        getVeiculos(queryParms = {}) {
            return repository.get(`${baseUrl}/veiculo?${urlUtil.serialize(queryParms)}`)
        },
        getMotivos(queryParms = {}) {
            return repository.get(`${baseUrl}/motivo?${urlUtil.serialize(queryParms)}`)
        }
    }
}